import { ev } from './utils';

import setFullHeight from './helpers/setFullHeight';
import initArticlesScroll from './components/articlesScroll';
import header from './components/header';
import headerCnn from './components/header-cnn';
import article from './components/article';
import initQuiz from './components/quiz';
import menu from './components/menu';
import initAisle from './components/aisle/aisle';
import initVideo from './components/video/';
import initVideoOverlay from './components/video/overlay';

import { animationSplashScreen } from './components/splash';

export default () => {
	if ('ontouchstart' in document.documentElement) {
		document.body.classList.add('touch');
	} else {
		document.body.classList.add('no-touch');
	}

	window.matchMedia('(orientation: portrait)').addListener(function (m) {
		location.reload();
		if (m.matches) {
			ev('orientationchange', { orientation: 'portrait' });
		} else {
			ev('orientationchange', { orientation: 'landscape' });
		}
	});

	window.videoOverlayShown = false;

	setFullHeight();
	animationSplashScreen();

	document.addEventListener('splashCompleted', (e) => {
		console.log('check');
		const template = document.querySelector(`[data-site-template]`);

		document.querySelector('[data-site-content]').appendChild(template.content.cloneNode(true));

		template.parentNode.removeChild(template);

		initVideo();
		initVideoOverlay();
		initArticlesScroll();
		menu();
		header();
		headerCnn();
		article();
		initQuiz();
		initAisle();
	});
};
